const unitOfMeasureMapping = {
    listings: 'month',
    days: 'day',
};

const SingleFamilyContractDetails = ({
    customerId = '',
    name = '',
    unitCost = null,
    unitOfMeasure = '',
} = {}) => ({
    customerId: String(customerId),
    name: String(name),
    unitCost: Number(unitCost),
    unitOfMeasure: String(unitOfMeasureMapping[unitOfMeasure]),
});

export default SingleFamilyContractDetails;
